import * as DomainConstants from "../../constants/DomainConstants";

import queryString from "query-string";
import { showToastrError } from "../../util/toastr.js";
import { getStore } from "../../store/configureStore";

export default class DossierPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		let dossierId = this.context.props.params.id;
		if (!dossierId) {
			const parsedQueryString = queryString.parse(this.context.props.location.search);
			dossierId = parsedQueryString.id;
		}

		this.context.props.loadLayout();
		this.context.props.loadSchaduwdossier(dossierId);
		this.context.props.loadMijnDossier(dossierId);
	}

	update(nextProps) {
		let dossierId = this.context.props.params.id;
		if (!dossierId) {
			const parsedQueryString = queryString.parse(this.context.props.location.search);
			dossierId = parsedQueryString.id;
		}

		if (this.context.props.finishedLoadingSchaduwDossier == false && nextProps.finishedLoadingSchaduwDossier == true) {
			if (dossierId) {
				const actualId = nextProps.schaduwdossier ? nextProps.schaduwdossier.dossierId : dossierId;
				nextProps.getContent(actualId, DomainConstants.DocumentTab.MijnDossier)
					.then(result => {
						if (result.success) {
							this.context.setState(
								{
									documenten: result.data
								});
						} else {
							showToastrError("Laden van het dossier is mislukt");
							throw new Error("getContent load failed"); //Stops promise
						}
					});
			}
		}
	}
}